import { API } from "apis";
import PageTitle from "components/common/PageTitle";
import TopHeader from "components/top/TopHeader";
import { ContextModel } from "models";
import React from "react";
import { Helmet } from "react-helmet-async";
import { FaRegPaperPlane } from "react-icons/fa";
import { useOutletContext } from "react-router-dom";
import { Utils } from "utils";

/**
 * 会社登録メールの送信 画面 （ログイン前）
 */
const CorpRegisterPage: React.FC = () => {
  const ctx = useOutletContext<ContextModel>();
  const didEffect = React.useRef(false);

  const [mail, setMail] = React.useState("");
  const [sended, setSended] = React.useState(false);

  const onSend = async () => {
    ctx.loading.setState(true);
    try {
      const response = await API.Auth.preAccessToken(mail);
      console.log(response);
      setSended(true);
    } catch (err) {
      Utils.errorAction(ctx, err);
    }
    ctx.loading.setState(false);
  };

  React.useEffect(() => {
    if (didEffect.current) {
      return;
    }
    didEffect.current = true;
    ctx.loading.setState(false);
  }, [ctx.loading]);

  if (!sended) {
    return (
      <div className="w-full mx-auto">
        <Helmet>
          <title>新規申込</title>
        </Helmet>
        <TopHeader />
        <form
          onSubmit={(event) => {
            event.preventDefault();
          }}
          className="text-center p-16"
        >
          <div className="text-2xl font-bold">新規申込</div>
          <div className="flex justify-center items-center gap-4 my-8">
            <div className="">メールアドレス</div>
            <input
              className="flex-1 max-w-md"
              value={mail}
              onChange={(e) => {
                const value = e.target.value;
                setMail(value);
              }}
            />
          </div>
          <button type="submit" className="primary px-4 py-2" onClick={onSend}>
            新規申込メール送信
          </button>
        </form>
      </div>
    );
  } else {
    return (
      <div className="w-full mx-auto">
        <Helmet>
          <title>新規申込完了</title>
        </Helmet>
        <TopHeader />
        <PageTitle title="新規申込完了" className="p-2" />
        <div className="mt-16 text-2xl font-bold text-center">新規申込メールの送信完了</div>
        <div className="flex justify-center m-8">
          <FaRegPaperPlane className="text-9xl" />
        </div>
        <div className="max-w-xl mx-auto">
          <div>入力されたメールアドレスに新規申込メールを送信しました。ご確認ください。メールが届きましたら、この画面を閉じてください。</div>
          <div className="mt-4">
          メールが届かない場合は、メールアドレスをご確認の上、再度申し込みをお試しください。再度申し込みをしても届かない場合は、お使いのメールサービス、メールソフト、ウイルス対策ソフト等の設定により「迷惑メール」と認識されている可能性がございます。ご確認ください。
          </div>
        </div>
      </div>
    );
  }
};

export default CorpRegisterPage;
